import { api } from './api';

import {
    AddRemovePointDto,
    EditPointDto,
    PointDto,
    SelfAddPointDto,
    UserPointsDto,
} from 'api/dtos/point';

export const pointsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getUserPoints: builder.query<PointDto[], { entityId: string; teamMemberId: string; includePending?: boolean }>({
            query: ({ entityId, teamMemberId, includePending = true }) =>
                `entity/${entityId}/points/team-member/${teamMemberId}?includePending=${includePending}`,
            providesTags: ['Points'],
        }),
        getUserCurrentYearPoints: builder.query<{ totalPoints: number }, { entityId: string; teamMemberId: string }>({
            query: ({ entityId, teamMemberId }) =>
                `entity/${entityId}/points/current-year-total/team-member/${teamMemberId}`,
            providesTags: ['Points'],
        }),
        getAllUsersPointsByEntity: builder.query<UserPointsDto[], string>({
            query: (entityId) => `entity/${entityId}/all-users`,
            providesTags: ['Points'],
        }),
        getPendingPoints: builder.query<PointDto[], string>({
            query: (entityId) => `entity/${entityId}/points/pending`,
            providesTags: ['Points'],
        }),
        getRankingByPeriod: builder.query<UserPointsDto[], { entityId: string; year?: number; month?: number }>({
            query: ({ entityId, year, month }) => {
                const params = new URLSearchParams();
                if (year) params.append('year', year.toString());
                if (month) params.append('month', month.toString());
                return `entity/${entityId}/points/ranking?${params.toString()}`;
            },
            providesTags: ['Points'],
        }),
        addOrRemovePoints: builder.mutation<PointDto, { entityId: string; data: AddRemovePointDto }>({
            query: ({ entityId, data }) => ({
                url: `entity/${entityId}/points/add-or-remove`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Points'],
            extraOptions: {
                successMessage: 'Punkty zostały pomyślnie zaktualizowane!',
                errorMessage: 'Nie udało się zaktualizować punktów. Spróbuj ponownie.',
            },
        }),
        selfAddPoint: builder.mutation<PointDto, { entityId: string; data: SelfAddPointDto }>({
            query: ({ entityId, data }) => ({
                url: `entity/${entityId}/points/self/request`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Points'],
            extraOptions: {
                successMessage: 'Prośba o punkty została wysłana!',
                errorMessage: 'Nie udało się wysłać prośby o punkty. Spróbuj ponownie.',
            },
        }),
        acceptPoint: builder.mutation<void, { entityId: string; id: string }>({
            query: ({ entityId, id }) => ({
                url: `entity/${entityId}/points/${id}/accept`,
                method: 'POST',
            }),
            invalidatesTags: ['Points'],
            extraOptions: {
                successMessage: 'Punkt został zaakceptowany!',
                errorMessage: 'Nie udało się zaakceptować punktu. Spróbuj ponownie.',
            },
        }),
        rejectPoint: builder.mutation<void, { entityId: string; id: string }>({
            query: ({ entityId, id }) => ({
                url: `entity/${entityId}/points/${id}/reject`,
                method: 'POST',
            }),
            invalidatesTags: ['Points'],
            extraOptions: {
                successMessage: 'Punkt został odrzucony!',
                errorMessage: 'Nie udało się odrzucić punktu. Spróbuj ponownie.',
            },
        }),
        updatePoint: builder.mutation<void, { entityId: string; data: EditPointDto }>({
            query: ({ entityId, data }) => ({
                url: `entity/${entityId}/points/${data.id}/update`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Points'],
            extraOptions: {
                successMessage: 'Punkt został pomyślnie zaktualizowany!',
                errorMessage: 'Nie udało się zaktualizować punktu. Spróbuj ponownie.',
            },
        }),
        deletePoint: builder.mutation<void, { entityId: string; id: string }>({
            query: ({ entityId, id }) => ({
                url: `entity/${entityId}/points/${id}/delete`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Points'],
            extraOptions: {
                successMessage: 'Punkt został pomyślnie usunięty!',
                errorMessage: 'Nie udało się usunąć punktu. Spróbuj ponownie.',
            },
        }),
        
    }),
});

export const {
    useGetUserPointsQuery,
    useGetUserCurrentYearPointsQuery,
    useGetAllUsersPointsByEntityQuery,
    useGetPendingPointsQuery,
    useGetRankingByPeriodQuery,
    useAddOrRemovePointsMutation,
    useSelfAddPointMutation,
    useAcceptPointMutation,
    useRejectPointMutation,
    useUpdatePointMutation,
    useDeletePointMutation,
} = pointsApi;
